import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Popup } from "@progress/kendo-react-popup";
import { icon, label, number } from "../../../../config";
import { popupAlign } from "../../../../helper/common";
import { onBlur, onFocus, onOpen } from "../../../../utils/kendo";
import { email_label } from "./TaskEmailConstant";

/**
 * EmailPopUpSidebar component for displaying email action options
 * @param {Object} props - Component props
 * @param {Object} props.anchor - Reference to the anchor element
 * @param {boolean} props.showPopup - Whether the popup is visible
 * @param {Function} props.setShowPopup - Function to control popup visibility
 * @param {Function} props.handleSpam - Function to handle spam action
 * @param {Function} props.handleDelete - Function to handle delete action
 * @param {string} props.EmailType - Type of email (incoming/outgoing)
 * @author Sejal
 */
const EmailPopUpSidebar = ({ anchor, showPopup, setShowPopup, handleSpam, handleDelete, EmailType }) => {
  const deleteRef = React.useRef(null);
  const blurTimeoutRef = React.useRef(null);
  const { totalDraftStreams } = useSelector((state) => state.allProjects);
  const dispatch = useDispatch();

  /**
   * Hides the popup
   * @author Sejal
   */
  const hidePopUp = () => {
    setShowPopup(false);
  };

  /**
   * Handles popup open event
   * @author Sejal
   */
  const onOpenPopup = () => {
    onOpen(deleteRef);
  };

  /**
   * Handles popup focus event
   * @author Sejal
   */
  const onFocusPopup = () => {
    onFocus(blurTimeoutRef);
  };

  /**
   * Handles popup blur event
   * @author Sejal
   */
  const onBlurPopup = () => {
    onBlur(blurTimeoutRef, hidePopUp);
  };

  return (
    <Popup
      popupClass={"dt-popup  email-pop-up-sidebar p-1"}
      show={showPopup}
      anchor={anchor?.current}
      onOpen={onOpenPopup}
      popupAlign={popupAlign("right", "top")}>
      <div tabIndex={number.ZERO} ref={deleteRef} onFocus={onFocusPopup} onBlur={onBlurPopup}>
        <div>
          {EmailType !== email_label.OUTGOING_EMAIL_CONSTANT && EmailType !== email_label.COMPOSE_EMAIL_CONSTANT && EmailType !== email_label.DRAFT_CONSTANT && (
            <label
              className='cursor-pointer  d-flex '
              onClick={(e) => {
                setShowPopup(false);
                handleSpam(e);
              }}>
              <span className='mr-2'>{icon.REPORT}</span>
              {email_label.MARK_AS_SPAM}
            </label>
          )}
          <label
            className='cursor-pointer  d-flex   '
            onClick={(e) => {
              setShowPopup(false);
              handleDelete(e);
            }}>
            <span className='mr-2'>{icon.DELETE_ICON_EMAIL}</span>
            {EmailType === email_label.DRAFT_CONSTANT ? email_label.DELETE_DRAFT : email_label.DELETE_EMAIL}
          </label>
        </div>
      </div>
    </Popup>
  );
};

export default EmailPopUpSidebar;
